import { LineItemSelector } from '@reveni-io/reveni-ui'

import { actionTypes } from '@/constants'
import useItemTransactionType from '@/hooks/useItemTransactionType/useItemTransactionType'

import * as Styles from './styles'

const SummaryItems = ({ summaryLineItems = [], isCancellationsPortal }) => {
  const { isItemForExchange } = useItemTransactionType()

  const items = summaryLineItems.map(item => {
    if (isCancellationsPortal) {
      item.actionType = actionTypes.cancellation
    } else {
      item.actionType = isItemForExchange(item) ? actionTypes.exchange : actionTypes.refund
    }
    return item
  })

  const getExchangedForItem = item => {
    if (item.exchange_info) return { exchange_info: item.exchange_info }

    if (isItemForExchange(item)) {
      return item.exchanged_for_item || item
    }
  }

  return (
    <>
      <Styles.ItemsToReturnContainer>
        {items.map((item, index) => (
          <LineItemSelector
            index={index + 1}
            key={item.id}
            lineItem={item}
            newItem={getExchangedForItem(item)}
            extraProducts={item?.new_items}
            selected
            clickable={false}
            showToggle={false}
            finished={true}
          />
        ))}
      </Styles.ItemsToReturnContainer>
    </>
  )
}

export default SummaryItems
